// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import store from '@/store/index'
import App from './App'
import router from './router'

import tanikawaIview from 'tanikawa-iview';
import 'tanikawa-iview/dist/styles/iview.css';

import './theme/index.less';

import './icons';
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false

Vue.use(tanikawaIview);
Vue.use(VueClipboard);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
